// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1phP4","title":"styles_title__6mrZj","item":"styles_item__LT1OE"};